export type PackScopeFilterValue = 'global' | 'studio_specific';
export type PackStatusFilterValue = 'active' | 'inactive';
export type PackSortFilterValue =
  | 'price_asc'
  | 'price_desc'
  | 'most_purchased'
  | 'least_purchased'
  | 'created_newest'
  | 'created_oldest';

export interface PackStudioOption {
  _id: string;
  studioName: string;
  city?: string;
}

export interface PackAdvancedFilters {
  scope: PackScopeFilterValue | null;
  studioIds: string[];
  status: PackStatusFilterValue | null;
  sort: PackSortFilterValue | null;
}

export const EMPTY_PACK_ADVANCED_FILTERS: PackAdvancedFilters = {
  scope: null,
  studioIds: [],
  status: null,
  sort: null,
};

export type StatusFilterValue = 'active' | 'inactive';
export type SubscriptionFilterValue = 'subscribed' | 'not_subscribed';
export type CategoryFilterValue = 'workout' | 'wellness';
export type SortByFilterValue = 'subscribers' | 'revenue';
export type SortDirFilterValue = 'desc' | 'asc';

export interface StudioAdvancedFilters {
  status: StatusFilterValue | null;
  subscription: SubscriptionFilterValue | null;
  category: CategoryFilterValue | null;
  sortBy: SortByFilterValue | null;
  sortDir: SortDirFilterValue | null;
}

export const EMPTY_STUDIO_ADVANCED_FILTERS: StudioAdvancedFilters = {
  status: null,
  subscription: null,
  category: null,
  sortBy: null,
  sortDir: null,
};

export type GenderFilter = 'Female' | 'Male';
export type MarketableFilter = 'yes' | 'no';
export type UserPackFilter = 'active' | 'upcoming' | 'expired' | 'none';

export interface UserAdvancedFilters {
  gender: GenderFilter | null;
  marketable: MarketableFilter | null;
  pack: UserPackFilter | null;
  cities: string[];
}

export const EMPTY_USER_ADVANCED_FILTERS: UserAdvancedFilters = {
  gender: null,
  marketable: null,
  pack: null,
  cities: [],
};
